<div class="beverage-container">
    <app-myspice-nav-bar></app-myspice-nav-bar>
    <div class="content-container">
        <h3>We are currently BYOB. For wine service, we charge a corkage fee of $20 per bottle. Thank you :)</h3>
    </div>
</div>
